// extracted by mini-css-extract-plugin
export var link = "product-module--link--k95tR";
export var links = "product-module--links--KjJBF";
export var otherCategories = "product-module--other-categories--SAXrH";
export var productDescription = "product-module--product-description--heTzs";
export var productDescriptionHeadline = "product-module--product-description-headline--sO9lJ";
export var similar = "product-module--similar--pfnw+";